export const GET_DOCUMENT = 'GET_DOCUMENT';
export const SET_DOCUMENT_LOADING = 'SET_DOCUMENT_LOADING';
export const SET_LARGE_PAGE_LOADING = 'SET_LARGE_PAGE_LOADING';
export const SET_CURRENT_DOCUMENT = 'SET_CURRENT_DOCUMENT';
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';

export const RELATED_DOCUMENTS = 'RELATED_DOCUMENTS';
export const RELATED_SECTIONS = 'RELATED_SECTIONS';

export const SEARCH_LOADING = 'SEARCH_LOADING';
export const SEARCH = 'SEARCH';
export const CLEAR_SEARCH = 'CLEAR_SEARCH';

export const DOC_SEARCH_LOADING = 'DOC_SEARCH_LOADING';
export const DOC_SEARCH = 'DOC_SEARCH';
export const CLEAR_DOC_SEARCH = 'CLEAR_DOC_SEARCH';
